(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.hurdler = factory());
}(this, (function () { 'use strict';

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

















var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

/**
 * Enables hash links to web page content hidden beneath layers of interaction.
 * @see https://github.com/jaydenseric/Hurdler
 * @version 3.0.0
 * @author Jayden Seric
 * @license MIT
 */
var Hurdler = function () {
  /**
   * Constructs a new Hurdler instance with options.
   * @param {string} [hashPrefix=/] - String between URL hash symbol and target element ID to denote Hurdler links. Prevents auto scroll.
   * @example
   * // Operates on URL hash changes via href="#/my-element-id"
   * const hurdler = new Hurdler()
   * @example
   * // Operates on URL hash changes via href="#!/my-element-id"
   * const hurdler = new Hurdler('!/')
   */
  function Hurdler() {
    var _this = this;

    var hashPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    classCallCheck(this, Hurdler);

    this.hashPrefix = hashPrefix;
    this.before = [];
    this.hurdles = [];
    this.after = [];
    // Run Hurdler every URL hash change
    window.addEventListener('hashchange', function () {
      _this.run();
    });
  }

  /**
   * Sets the URL hash, triggering a run.
   * @param {string} id - Target element ID.
   * @example
   * hurdler.setHash('my-element-id')
   */


  createClass(Hurdler, [{
    key: 'setHash',
    value: function setHash(id) {
      window.location.hash = this.hashPrefix + id;
    }

    /**
     * Gets the target element ID from the URL hash.
     * @returns {string|boolean} Target element ID or false if the URL hash is not set or invalid.
     */

  }, {
    key: 'getTargetId',
    value: function getTargetId() {
      var hash = window.location.hash.split('#' + this.hashPrefix);
      return hash.length === 2 ? hash[1] : false;
    }

    /**
     * Clears the URL hash if it contains a specific ID.
     * @param {string} id - Element ID.
     * @example
     * hurdler.clearHash('my-element-id')
     */

  }, {
    key: 'clearHash',
    value: function clearHash(id) {
      if (window.location.hash === '#' + this.hashPrefix + id) {
        if (window.history.pushState) window.history.pushState('', document.title, window.location.pathname + window.location.search);else window.location.hash = this.hashPrefix;
      }
    }

    /**
     * Finds hurdles and runs callbacks for the current URL hash. Use this after all hurdles have been setup and the document is ready. URL hash changes automatically trigger a run.
     */

  }, {
    key: 'run',
    value: function run() {
      var _this2 = this;

      // Progress if a URL hash is set
      if (window.location.hash) {
        // Check hash matches the configured Hurdler format
        var id = this.getTargetId();
        if (id) {
          (function () {
            var element = document.querySelector('#' + id);
            // Progress if the element exists
            if (element) {
              (function () {
                // Establish the run session
                var session = {
                  target: element,
                  hurdles: []
                };
                // Start at the hash target and loop up the DOM
                for (; element && element !== document; element = element.parentNode) {
                  // Check if element is a hurdle
                  _this2.hurdles.forEach(function (hurdle) {
                    var passes = false;
                    try {
                      passes = hurdle.test.call(element, session);
                    } catch (error) {
                      // Swallow errors
                    }
                    if (passes) {
                      // Update list of found hurdles
                      session.hurdles.unshift({
                        element: element,
                        test: hurdle.test,
                        callback: hurdle.callback
                      });
                    }
                  });
                }
                // Run before run callbacks
                _this2.before.forEach(function (callback) {
                  callback.call(session.target, session);
                });
                // Run hurdle callbacks
                session.hurdles.forEach(function (hurdle) {
                  hurdle.callback.call(hurdle.element, session);
                });
                // Run after run callbacks
                _this2.after.forEach(function (callback) {
                  callback.call(session.target, session);
                });
              })();
            }
          })();
        }
      }
    }
  }]);
  return Hurdler;
}();

return Hurdler;

})));
//# sourceMappingURL=hurdler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hurdler/dist/hurdler.js
// module id = 5
// module chunks = 0